<script>
  import DatePickerModal from "../Modals/DatePickerModal.svelte";
  import { createDatePickerContext } from "./context.svelte.js";
  import DatePickerSelector from "./DatePickerComponents/DatePickerSelector.svelte";

  let {
    initialDate = null, // TODO deprecate with onChange - one component uses this
    allowFuture = true,
    allowPast = true,
    includeTime = false,
    placeholder = "No date selected",
    label = "Select date",
    disabled = false,
    selectedDate = $bindable(initialDate),
    reset = $bindable(),
  } = $props();

  const datePickerContext = createDatePickerContext({
    getSelectedDate: () => selectedDate,
    setSelectedDate: (date) => {
      selectedDate = date;
    },
    selectedDate,
    allowFuture,
    allowPast,
    includeTime,
  });

  reset = () => {
    datePickerContext.reset();
  };

  const onclose = () => {
    datePickerContext.showModal = false;
  };
</script>

{#if datePickerContext.showModal}
  <DatePickerModal {onclose} />
{/if}
<DatePickerSelector {label} {placeholder} {disabled} />
